var _path, _path2, _line, _path3, _line2, _path4, _path5, _path6, _path7, _path8, _rect, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _rect2, _rect3, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _rect4, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect5, _rect6, _rect7, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTempAndHumidityHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 250,
    viewBox: "0 0 173 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.78 112.308V25.5427C142.78 22.4815 140.399 20 137.46 20H124.692V24.4341C124.692 26.2708 123.263 27.7597 121.5 27.7597H103.411C101.648 27.7597 100.219 26.2708 100.219 24.4341V20H86.3866C83.4483 20 81.0664 22.4815 81.0664 25.5427V112.308H142.78Z",
    fill: "#F3F3F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.071 230H86.3866C83.4483 230 81.0664 227.403 81.0664 224.199V25.8011C81.0664 22.5972 83.4483 20 86.3866 20H100.219V24.6409C100.219 26.5632 101.648 28.1215 103.411 28.1215H121.5C123.263 28.1215 124.692 26.5632 124.692 24.6409V20H137.46C140.399 20 142.78 22.5972 142.78 25.8011V224.199C142.78 227.403 140.399 230 137.46 230H123.6",
    stroke: "#444444",
    strokeWidth: 0.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 81.3516,
    y1: 119.249,
    x2: 86.6717,
    y2: 119.249,
    stroke: "#444444",
    strokeWidth: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.891 119.226L106.889 119.227",
    stroke: "#444444",
    strokeWidth: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.3,
    x2: 5.32018,
    y2: -0.3,
    transform: "matrix(-1 0 0 1 143.066 119.549)",
    stroke: "#444444",
    strokeWidth: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3555 119.549L86.3555 114.375L93.9088 114.375",
    stroke: "#444444",
    strokeWidth: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116.891 119.549L116.891 114.375L124.444 114.375",
    stroke: "#444444",
    strokeWidth: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.207 119.549L107.207 114.375L99.7011 114.375",
    stroke: "#444444",
    strokeWidth: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M137.746 119.549L137.746 114.375L130.24 114.375",
    stroke: "#444444",
    strokeWidth: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100.07 230.001V226.715H123.778V230.001",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 86.257,
    y: 125.06,
    width: 21.603,
    height: 88.4135,
    rx: 1.7,
    fill: "#F8F8F8",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 88.4141,
    y1: 115.737,
    x2: 105.706,
    y2: 115.737,
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 89.3203,
    y1: 118.341,
    x2: 104.792,
    y2: 118.341,
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 105.403,
    y1: 222.136,
    x2: 88.7108,
    y2: 222.136,
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 104.493,
    y1: 219.792,
    x2: 89.6209,
    y2: 219.792,
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 103.583,
    y1: 217.448,
    x2: 90.531,
    y2: 217.448,
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 102.673,
    y1: 215.105,
    x2: 91.4411,
    y2: 215.105,
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 91.1406,
    y1: 120.952,
    x2: 102.972,
    y2: 120.952,
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 93.3164,
    y: 122.439,
    width: 7.48443,
    height: 2.64173,
    fill: "#F8F8F8",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 138.036,
    y: 213.887,
    width: 21.603,
    height: 88.4135,
    rx: 1.7,
    transform: "rotate(-180 138.036 213.887)",
    fill: "#F8F8F8",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 135.579,
    y1: 223.21,
    x2: 118.887,
    y2: 223.21,
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 134.673,
    y1: 220.607,
    x2: 119.801,
    y2: 220.607,
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 118.59,
    y1: 116.811,
    x2: 135.882,
    y2: 116.811,
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 119.5,
    y1: 119.155,
    x2: 134.972,
    y2: 119.155,
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 120.41,
    y1: 121.499,
    x2: 134.062,
    y2: 121.499,
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 121.32,
    y1: 123.843,
    x2: 133.152,
    y2: 123.843,
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 132.852,
    y1: 217.995,
    x2: 121.621,
    y2: 217.995,
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 130.977,
    y: 216.508,
    width: 7.48443,
    height: 2.64173,
    transform: "rotate(-180 130.977 216.508)",
    fill: "#F8F8F8",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1211 224.758H138.572",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2461 147.689V185.43",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M112.332 158.715L112.332 178.19",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M108.25 158.715H116.423",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M108.25 168.453H116.423",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M128.613 154.049L123.684 152.35L123.684 151.323L129.371 153.463L129.371 154.12L128.613 154.049ZM123.684 155.471L128.613 153.768L129.371 153.694L129.371 154.354L123.684 156.503L123.684 155.471ZM125.793 155.389L125.016 155.389L125.016 152.296L125.793 152.296L125.793 155.389ZM128.613 159.354L123.684 157.655L123.684 156.628L129.371 158.768L129.371 159.424L128.613 159.354ZM123.684 160.776L128.613 159.073L129.371 158.999L129.371 159.659L123.684 161.807L123.684 160.776ZM125.793 160.694L125.016 160.694L125.016 157.6L125.793 157.6L125.793 160.694ZM128.613 164.659L123.684 162.96L123.684 161.932L129.371 164.073L129.371 164.729L128.613 164.659ZM123.684 166.081L128.613 164.378L129.371 164.303L129.371 164.963L123.684 167.112L123.684 166.081ZM125.793 165.999L125.016 165.999L125.016 162.905L125.793 162.905L125.793 165.999ZM129.391 172.163L123.684 172.163L123.684 171.221L128.273 171.221L127.801 169.827L128.578 169.827L129.391 172.049L129.391 172.163ZM124.152 174.233C124.298 174.233 124.421 174.282 124.52 174.381C124.621 174.48 124.672 174.615 124.672 174.784C124.672 174.956 124.621 175.09 124.52 175.186C124.421 175.285 124.298 175.335 124.152 175.335C124.007 175.335 123.884 175.285 123.785 175.186C123.686 175.09 123.637 174.956 123.637 174.784C123.637 174.615 123.686 174.48 123.785 174.381C123.884 174.282 124.007 174.233 124.152 174.233ZM126.328 177.354L126.512 176.604L129.371 176.913L129.371 179.979L128.574 179.979L128.574 177.694L127.18 177.538C127.232 177.626 127.283 177.749 127.332 177.905C127.384 178.061 127.41 178.24 127.41 178.44C127.41 178.708 127.366 178.948 127.277 179.159C127.191 179.372 127.065 179.553 126.898 179.702C126.734 179.85 126.534 179.963 126.297 180.042C126.062 180.12 125.798 180.159 125.504 180.159C125.241 180.159 124.995 180.12 124.766 180.042C124.536 179.966 124.335 179.852 124.16 179.698C123.986 179.544 123.849 179.35 123.75 179.116C123.654 178.884 123.605 178.609 123.605 178.292C123.605 178.055 123.639 177.827 123.707 177.608C123.777 177.392 123.88 177.198 124.016 177.026C124.154 176.854 124.323 176.716 124.523 176.612C124.727 176.508 124.96 176.448 125.223 176.432L125.223 177.354C125.038 177.378 124.88 177.428 124.75 177.506C124.622 177.587 124.525 177.694 124.457 177.827C124.389 177.96 124.355 178.113 124.355 178.288C124.355 178.447 124.383 178.583 124.437 178.698C124.495 178.812 124.576 178.907 124.68 178.983C124.786 179.061 124.911 179.118 125.055 179.155C125.198 179.194 125.357 179.213 125.531 179.213C125.698 179.213 125.85 179.191 125.988 179.147C126.126 179.105 126.246 179.042 126.348 178.956C126.449 178.872 126.527 178.767 126.582 178.639C126.639 178.512 126.668 178.365 126.668 178.198C126.668 177.974 126.635 177.802 126.57 177.682C126.505 177.565 126.424 177.456 126.328 177.354ZM124.723 183.01L129.371 184.506L129.371 185.588L123.684 183.549L123.684 182.819L124.723 183.01ZM129.371 181.628L124.723 183.112L123.684 183.315L123.684 182.581L129.371 180.549L129.371 181.628Z",
    fill: "#DADADA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7422 154.049L93.8125 152.35L93.8125 151.323L99.5 153.463L99.5 154.12L98.7422 154.049ZM93.8125 155.471L98.7422 153.768L99.5 153.694L99.5 154.354L93.8125 156.503L93.8125 155.471ZM95.9219 155.389L95.1445 155.389L95.1445 152.296L95.9219 152.296L95.9219 155.389ZM98.7422 159.354L93.8125 157.655L93.8125 156.628L99.5 158.768L99.5 159.424L98.7422 159.354ZM93.8125 160.776L98.7422 159.073L99.5 158.999L99.5 159.659L93.8125 161.807L93.8125 160.776ZM95.9219 160.694L95.1445 160.694L95.1445 157.6L95.9219 157.6L95.9219 160.694ZM98.7422 164.659L93.8125 162.96L93.8125 161.932L99.5 164.073L99.5 164.729L98.7422 164.659ZM93.8125 166.081L98.7422 164.378L99.5 164.303L99.5 164.963L93.8125 167.112L93.8125 166.081ZM95.9219 165.999L95.1445 165.999L95.1445 162.905L95.9219 162.905L95.9219 165.999ZM99.5195 172.163L93.8125 172.163L93.8125 171.221L98.4023 171.221L97.9297 169.827L98.707 169.827L99.5195 172.049L99.5195 172.163ZM94.2812 174.233C94.4271 174.233 94.5495 174.282 94.6484 174.381C94.75 174.48 94.8008 174.615 94.8008 174.784C94.8008 174.956 94.75 175.09 94.6484 175.186C94.5495 175.285 94.4271 175.335 94.2812 175.335C94.1354 175.335 94.013 175.285 93.9141 175.186C93.8151 175.09 93.7656 174.956 93.7656 174.784C93.7656 174.615 93.8151 174.48 93.9141 174.381C94.013 174.282 94.1354 174.233 94.2812 174.233ZM96.457 177.354L96.6406 176.604L99.5 176.913L99.5 179.979L98.7031 179.979L98.7031 177.694L97.3086 177.538C97.3607 177.626 97.4115 177.749 97.4609 177.905C97.513 178.061 97.5391 178.24 97.5391 178.44C97.5391 178.708 97.4948 178.948 97.4062 179.159C97.3203 179.372 97.194 179.553 97.0273 179.702C96.8633 179.85 96.6628 179.963 96.4258 180.042C96.1914 180.12 95.9271 180.159 95.6328 180.159C95.3698 180.159 95.1237 180.12 94.8945 180.042C94.6654 179.966 94.4635 179.852 94.2891 179.698C94.1146 179.544 93.9779 179.35 93.8789 179.116C93.7826 178.884 93.7344 178.609 93.7344 178.292C93.7344 178.055 93.7682 177.827 93.8359 177.608C93.9062 177.392 94.0091 177.198 94.1445 177.026C94.2826 176.854 94.4518 176.716 94.6523 176.612C94.8555 176.508 95.0885 176.448 95.3516 176.432L95.3516 177.354C95.1667 177.378 95.0091 177.428 94.8789 177.506C94.7513 177.587 94.6536 177.694 94.5859 177.827C94.5182 177.96 94.4844 178.113 94.4844 178.288C94.4844 178.447 94.5117 178.583 94.5664 178.698C94.6237 178.812 94.7044 178.907 94.8086 178.983C94.9154 179.061 95.0404 179.118 95.1836 179.155C95.3268 179.194 95.4857 179.213 95.6602 179.213C95.8268 179.213 95.9792 179.191 96.1172 179.147C96.2552 179.105 96.375 179.042 96.4766 178.956C96.5781 178.872 96.6562 178.767 96.7109 178.639C96.7682 178.512 96.7969 178.365 96.7969 178.198C96.7969 177.974 96.7643 177.802 96.6992 177.682C96.6341 177.565 96.5534 177.456 96.457 177.354ZM94.8516 183.01L99.5 184.506L99.5 185.588L93.8125 183.549L93.8125 182.819L94.8516 183.01ZM99.5 181.628L94.8516 183.112L93.8125 183.315L93.8125 182.581L99.5 180.549L99.5 181.628Z",
    fill: "#DADADA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M108.25 178.189H116.423",
    stroke: "#444444",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 30.2336,
    y: 20.3,
    width: 61.4,
    height: 209.4,
    rx: 4.7,
    fill: "#F8F8F8",
    stroke: "#444444",
    strokeWidth: 0.6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 30.2336,
    y: 20.3,
    width: 61.4,
    height: 204.157,
    rx: 4.7,
    fill: "white",
    stroke: "#444444",
    strokeWidth: 0.6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 32.2703,
    y: 22.4637,
    width: 57.3241,
    height: 199.832,
    rx: 3.8,
    fill: "white",
    stroke: "#C6C3C3",
    strokeWidth: 0.4
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6049 171.594H82.8725C80.2009 171.594 78.0352 173.602 78.0352 176.08C78.0352 178.558 80.2009 180.567 82.8725 180.567H91.6049V171.594Z",
    fill: "white",
    stroke: "#444444",
    strokeWidth: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempAndHumidityHelp);
export default __webpack_public_path__ + "static/media/temp-and-humidity-help.a076bec76f075865a6a5f59ce4f643dc.svg";
export { ForwardRef as ReactComponent };